<template>
    <div class="dashboard-container">
        <side-bar />
        <div class="main-content">
            <h2>Version History and Upcoming Features</h2>
            <hr class="h2" />
            <div class="flex-container">
                <div class="left-section">
                    <div class="ver-box">
                        <h3>Current Version</h3>

                        <h4>Version 1.1</h4>
                        <p>
                            <b>Release Date: </b> Sep 1st, 2024<br>
                            <b>Summary of changes: </b><br>
                        </p>
                        <ul>
                            <li>Add new opportinity</li>
                            <li>Add new customer</li>
                            <li>View and filter customers</li>
                        </ul>
                    </div>
                    <h3>Release History</h3>
                    <div class="ver-box">
                        <h4>Version 1.0</h4>
                        <p>
                            <b>Release Date: </b> Aug 1st, 2024<br>
                            <b>Summary of changes: </b><br>
                        </p>
                        <ul>
                            <li>Distributor dashboard</li>
                            <li>View and filter opportunities</li>
                            <li>View and filter partners</li>
                            <li>Add new partner</li>
                            <li>View and filter customers</li>
                            <li>View and update user login details and company profile</li>
                        </ul>
                    </div>
                </div>

                <div class="right-section">
                    <div id="future-rel">
                        <h3>Upcoming Features</h3>
                        <h4>Version 1.2</h4>
                        <p>
                            <b>Planned Release Date: </b>Oct 1st, 2024<br>
                            <b>Summary of changes: </b> Conversation History
                        </p>
                    </div>
                    <h3>FAQs</h3>

                    <h4>Question: How can I view the list of customers for my partners?</h4>
                    <p>
                        Go to Customers -> Filter the list of customers by the required partner company using the search
                        and filter options.
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import SideBar from './SideBar.vue'

export default {
    name: 'DistributorDashboard',
    components: {
        SideBar
    }
}
</script>


<style scoped>
.dashboard-container {
    display: flex;
    height: 100vh;
}

.main-content {
    flex: 1;
    padding: 20px;
}

h1 {
    margin-top: 10px;
}

#future-rel {
    border: 1px solid grey;
    padding: 10px;
    margin-bottom: 20px;
    max-width: 400px;
}

.ver-box {
    padding: 10px 0;
    margin-bottom: 20px;
}

/* .container {
    display: flex;
    max-width: 980px;
    width: 100%;
    margin: 0 auto;
    padding: 20px;
}

.container-btn {
    display: flex;
    max-width: 980px;
    margin: 0 auto;
    padding: 20px;
    justify-content: flex-end;
}

.logout-button-container {
    display: flex;
}

.logout-button {
    background-color: #E6C7EB;
    color: black;
    padding: 10px 20px;
    text-decoration: none;
    border-radius: 50px;
    cursor: pointer;
    flex: 1;
}

.logout-button:hover {
    background-color: #FE602F;
} */
.flex-container {
    display: flex;
    flex-direction: row;
    text-align: left;
    padding-top: 20px;
}

.container {
    max-width: 980px;
    margin: 20px;
}

.left-section {
    /* max-width: 760px; */
    width: 45%;
}

.right-section {
    width: 25%;
    max-width: 600px;
}

h3 {
    font-size: 22px;
    color: grey;
}

h4 {
    font-size: 18px;
    margin: 20px 0 10px 0;
}
</style>